import { z } from 'zod';
import { NumberProvider } from '../enums.js';
/**
 * `phoneNumbers/{e164}` — top-level reverse index for O(1) inbound lookup
 * (called-number -> business). Server-only (rules deny all client access).
 */
export const PhoneNumberMappingSchema = z.object({
    /**
     * `business` — a number held by one business (doc 13a); `businessId` names it.
     * `pool` — a SHARED inbound number (doc 18); it belongs to no business and
     * `businessId` is absent, so callers are resolved through `divertSources`
     * instead. Defaults to `business` so pre-doc-18 index documents parse
     * unchanged.
     */
    kind: z.enum(['business', 'pool']).default('business'),
    /** Absent for `kind: 'pool'` — which is why every read of this field must be
     * guarded rather than assumed. */
    businessId: z.string().min(1).optional(),
    /** ISO country of the number. Required in practice for pool numbers: it is
     * the default country used to reduce a national-format `ForwardedFrom` to a
     * routing key, and without it a T-Mobile-shaped divert cannot be resolved. */
    isoCountry: z.string().length(2).optional(),
    /** Which vendor owns this number. The gateway picks the media adapter + webhook
     * signature scheme by this (doc 17 §7). Defaults to `twilio` so pre-split index
     * docs still parse. */
    provider: NumberProvider.default('twilio'),
    /** Twilio number SID (twilio-owned numbers). Optional: telnyx numbers have none. */
    twilioNumberSid: z.string().optional(),
    /** Telnyx phone-number id (telnyx-owned numbers) — needed to release the number. */
    telnyxNumberId: z.string().optional(),
    /** Twilio subaccount that owns the number — the gateway resolves the webhook
     * signing token from this (doc 05 §4.13). Absent for legacy parent-owned/seeded numbers. */
    subaccountSid: z.string().optional(),
    /** The `numbers` subcollection doc id backing this mapping. */
    numberId: z.string().optional(),
});
//# sourceMappingURL=phoneNumber.js.map